var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"loadingio-spinner-wedges-u8574bzr5w"},[_c('div',{staticClass:"ldio-byq5psenbvn"},[_c('div',[_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')])])])])])
}]

export { render, staticRenderFns }